export const Groups = {
  MERCHANTS: 'merchants',
  ITEMS: 'items',
  HISTORY: 'history',
};
